import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();
    const savedLang = localStorage.getItem('i18nextLng') || "en";

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        window.location.reload();
    };
    return (
        <>
            <li className="nav-item">
                <select className="form-control"
                    value={ savedLang }
                    onChange={ (e) => changeLanguage(e.target.value) }>
                    <option value="en">English</option>
                    <option value="zh_HK">Chinese</option>
                </select>
            </li>
        </>
    );
};

export default LanguageSwitcher;